import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Our web inquiry is currently being updated.',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Please contact us by phone 818-998-3030, or email us at sales@liquidcatering.net',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'We are looking forward to hearing from you!',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Liquid Catering'
          }
        ]
      }
    ]
    },
    info: {
        title: 'Liquid Catering California Contact Form',
        formId: '1924',
        clientKey: 'FB09A47E-2A6A-4BFA-86BF-CFFE8F57AA59',
        appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
        submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
        redirectUrl: 'http://www.liquidcatering.net/',
        apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
    }
};


export default FormStructure;